/* These values represent the key in the localstore or cookies
to caches corresponding experiments status on the clients
*/
export const EXPERIMENT_STORE = {
  CLIENT_ID: 'experiment_client_id',
  ACTIVE_EXPERIMENTS: 'active_experiments',
  PLATFORM: 'web',
  ASSIGNED_EXPERIMENTS: 'assigned_experiments',
  LOGGED_EXPERIMENTS: 'logged_experiments',
};
